import { PauseCircle, PlayCircle, VolumeDown, VolumeUp } from '@mui/icons-material';
import { Box, IconButton } from '@mui/material';
import React, { Component, useState, useRef, useEffect } from 'react';
import WaveSurfer from 'wavesurfer.js';


const formWaveSurferOptions = (ref) => ({
    container: ref, // sets the container to render the instance of wavesurfer
    waveColor: '//ccc', //sets the color of the waveform
    progressColor: '//0178ff', //sets the color of playback
    cursorColor: 'transparent', //sets the color of the cursor indicating the current playback position.
    responsive: true, //should it be responsive to changes in container size
    height: 80, //height of waveform display
    normalize: true, //Adjust audio levels to ensure consistency in visualization
    barWidth: 2, //sets the width of each bar in waveform visualization
    barGap: 3, //sets gap between adjacent bars
});

function formatTime(seconds) { //1
    let date = new Date(0); //2
    date.setSeconds(seconds); //3
    return date.toISOString().substr(11, 8); //4   
}

function MyAudioPlayer({currentSong}) {
    const waveformRef = useRef(null); //1
    const wavesurfer = useRef(null); //2
    const [playing, setPlaying] = useState(false); //3
    const [volume, setVolume] = useState(0.5); //4
    const [muted, setMuted] = useState(false); //5
    const [duration, setDuration] = useState(0); //6
    const [currentTime, setCurrentTime] = useState(0); //7
    const [audioFileName, setAudioFileName] = useState(''); //8

    useEffect(() => {
        const options = formWaveSurferOptions(waveformRef.current); //1
        wavesurfer.current = WaveSurfer.create(options); //2
        wavesurfer.current.load(currentSong); //3

        wavesurfer.current.on('ready', () => {    //4
            setVolume(wavesurfer.current.getVolume());
            setDuration(wavesurfer.current.getDuration());
            setAudioFileName(currentSong.split('/').pop());
        });

        wavesurfer.current.on('audioprocess', () => { //5
            setCurrentTime(wavesurfer.current.getCurrentTime());
        });

        return () => {                               //6
            wavesurfer.current.un('audioprocess');
            wavesurfer.current.un('ready');
            wavesurfer.current.destroy();
        };
    }, [currentSong]);

    const handlePlayPause = () => { //1
        setPlaying(!playing);
        wavesurfer.current.playPause();
    };

    const handleVolumeChange = (newVolume) => { //2
        setVolume(newVolume);
        wavesurfer.current.setVolume(newVolume);
        setMuted(newVolume === 0);
    };

    const handleMute = () => { //3
        setMuted(!muted);
        wavesurfer.current.setVolume(muted ? volume : 0);
    };

    const handleVolumeUp = () => { //4
        handleVolumeChange(Math.min(volume + 0.1, 1));
    };

    const handleVolumeDown = () => { //5
        handleVolumeChange(Math.max(volume - 0.1, 0));
    };

    return (
        <Box>
            <Box id='waveform' ref={waveformRef} style={{ width: '100%' }}></Box>
            <Box className='controls'>
                <IconButton onClick={handlePlayPause} size='small'>
                    {playing ? <PauseCircle /> : <PlayCircle />}
                </IconButton>
                {/* <IconButton onClick={handleMute} size='small'>
                    {muted ? "unmute" : "mute"}
                </IconButton> */}
                {/* <input
                    type='range'
                    id='volume'
                    name='volume'
                    min='0'
                    max='1'
                    step='0.05'
                    value={muted ? 0 : volume}
                    onChange={(e) => handleVolumeChange(parseFloat(e.target.value))}
                /> */}
                <IconButton onClick={handleVolumeDown} size='small'>
                    <VolumeDown />
                </IconButton>
                <IconButton onClick={handleVolumeUp} size='small'>
                    <VolumeUp />
                </IconButton>
            </Box>
            <div className='audio-info'>
                <span>
                    Playing: {audioFileName} <br />
                </span>
                <span>
                    Duration: {formatTime(duration)} | Current Time:{' '}
                    {formatTime(currentTime)} <br />
                </span>
                <span>Volume: {Math.round(volume * 100)}%</span>
            </div>
        </Box>
    );
}
export default MyAudioPlayer;